import { Opportunity } from '@/controllers/Opportunity';
import { ReduxAction } from '@/types';

import { GlobalActionTypes } from './action-types';

export const setGlobalError = (error: Error): ReduxAction => ({
  type: GlobalActionTypes.SET_GLOBAL_ERROR,
  payload: error,
});

export const clearGlobalError = (): ReduxAction => ({
  type: GlobalActionTypes.CLEAR_GLOBAL_ERROR,
});

export const openTrainingRequiredModal = (onCloseCallback?: () => void): ReduxAction => ({
  type: GlobalActionTypes.TRAINING_REQUIRED_MODAL.OPEN,
  payload: { onCloseCallback },
});

export const closeTrainingRequiredModal = (): ReduxAction => ({
  type: GlobalActionTypes.TRAINING_REQUIRED_MODAL.CLOSE,
});

export const openSubmitOrderModal = (
  opportunityId: Opportunity['id'],
  updateDetails?: boolean,
): ReduxAction => ({
  type: GlobalActionTypes.SUBMIT_ORDER_MODAL.TRY_OPEN,
  payload: { opportunityId, updateDetails },
});

export const closeSubmitOrderModal = (): ReduxAction => ({
  type: GlobalActionTypes.SUBMIT_ORDER_MODAL.CLOSE,
});

export const closeAcceptLeadsPassingModal = (): ReduxAction => ({
  type: GlobalActionTypes.ACCEPT_LEADS_PASSING_MODAL.CLOSE,
});
